import React from 'react'
import ScrollWrap from '../components/ScrollWrap'
import Navbar from '../components/Navbar'
import MainWrap from '../components/MainWrap'
import ContactFormWrap from '../components/ContactFormWrap'
import Overlay from '../components/Overlay'
import SlickSlider2 from '../components/SlickSlider2'
import { SlickPlacementData } from '../data/SlickSliderData'
import FundamentalCourses2 from '../components/FundamentalCourses2'
import FundamentalPlacementData from '../data/FundamentalPlacementData'
import CounterArea from '../components/CounterArea'
import { CounterData2 } from '../data/CounterData'
import Enroll from '../components/Enroll'
import { EnrollData } from '../data/EnrollData'
import RelatedCourses from '../components/RelatedCourses'
import Footer from '../components/Footer'
import ContactAnchor from '../components/ContactAnchor'
import LoginAnchor from '../components/LoginAnchor'

export default function PlacementModule() {
    return (
        <>
            <ContactAnchor />
            <LoginAnchor /> 
            <ScrollWrap />
            <Navbar />
            <MainWrap />
            <ContactFormWrap />
            <Overlay />
            <SlickSlider2 data={SlickPlacementData} />
            <FundamentalCourses2 data={FundamentalPlacementData} />
            <CounterArea data={CounterData2} />
            <Enroll data={EnrollData} />
            <RelatedCourses />
            <Footer />
        </>
    )
}
